module.exports = __webpack_public_path__ + "static/media/New_Series_3_Ep4_Protein_planet_Desktop.284bebc8.jpg";